
import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const HourlyConsumptionChart: React.FC = () => {
  // Sample hourly consumption data
  const hourlyData = [
    { time: '00:00', energy: 120, gas: 45, water: 30 },
    { time: '02:00', energy: 100, gas: 40, water: 25 },
    { time: '04:00', energy: 80, gas: 35, water: 20 },
    { time: '06:00', energy: 150, gas: 50, water: 35 },
    { time: '08:00', energy: 280, gas: 65, water: 60 },
    { time: '10:00', energy: 350, gas: 70, water: 75 },
    { time: '12:00', energy: 320, gas: 75, water: 70 },
    { time: '14:00', energy: 300, gas: 70, water: 65 },
    { time: '16:00', energy: 350, gas: 65, water: 60 },
    { time: '18:00', energy: 400, gas: 80, water: 70 },
    { time: '20:00', energy: 300, gas: 70, water: 55 },
    { time: '22:00', energy: 200, gas: 55, water: 40 },
  ];

  return (
    <ResponsiveContainer width="100%" height="100%">
      <LineChart
        data={hourlyData}
        margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="time" />
        <YAxis />
        <Tooltip 
          formatter={(value, name) => {
            // Determine the unit based on the dataKey
            const unit = name === 'energy' ? 'kWh' : name === 'gas' ? 'm³' : 'm³';
            
            // Safely format the display name
            let displayName: string;
            if (typeof name === 'string') {
              displayName = name.charAt(0).toUpperCase() + name.slice(1);
            } else if (typeof name === 'number') {
              displayName = name.toString();
            } else {
              displayName = 'Unknown';
            }
            
            return [`${value} ${unit}`, displayName];
          }}
          contentStyle={{
            borderRadius: '8px',
            border: 'none',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
            backgroundColor: 'rgba(255, 255, 255, 0.97)'
          }}
        />
        <Line 
          type="monotone" 
          dataKey="energy" 
          name="Energy" 
          stroke="#30D158" 
          strokeWidth={2}
          dot={{ r: 3, strokeWidth: 1, fill: "#fff" }}
          activeDot={{ r: 6 }}
        />
        <Line 
          type="monotone" 
          dataKey="gas" 
          name="Gas" 
          stroke="#FF453A" 
          strokeWidth={2}
          dot={{ r: 3, strokeWidth: 1, fill: "#fff" }}
          activeDot={{ r: 6 }}
        />
        <Line 
          type="monotone" 
          dataKey="water" 
          name="Water" 
          stroke="#0EA5E9" 
          strokeWidth={2}
          dot={{ r: 3, strokeWidth: 1, fill: "#fff" }}
          activeDot={{ r: 6 }}
        />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default HourlyConsumptionChart;
